import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/StudyCalculatorImg.webp";
const TITLE = "تحويل المعدل الجامعي إلى النظام الألماني - بكالوريوس وماجستير";
const DESCRIPTION =
  "قم بتحويل معدلك الجامعي إلى النظام الألماني بسهولة ودقة. اعرف كيفية تحويل معدل البكالوريوس والماجستير إلى النظام الألماني باستخدام هذه الأداة المفيدة.";
const KEYWORDS =
  "تحويل المعدل الجامعي, تحويل إلى النظام الألماني, تحويل معدل البكالوريوس, تحويل معدل الماجستير, المعدل الجامعي, النظام الألماني";
const OG_URL = "https://do-calculate.com/calculator/ar/gradetogerman";
function GradeToGerman() {
  const [originalValue, setOriginalValue] = useState("");
  const [convertedValue, setConvertedValue] = useState("");
  const [conversionType, setConversionType] = useState("grade");
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const calculateGrade = (value) => {
    if (conversionType === "grade") {
      const grade = parseFloat(value);
      if (!isNaN(grade) && grade >= 0 && grade <= 100) {
        return (1 + (3 * (4 - grade / 25)) / 3).toFixed(2);
      }
    } else if (conversionType === "gpa") {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return (1 + (3 * (4 - gpa)) / 3).toFixed(2);
      }
    }
    return "مدخلات غير صالحة";
  };
  const getGradeTerm = (value) => {
    const grade = parseFloat(value);
    if (grade >= 1.0 && grade <= 1.5) {
      return "ممتاز";
    } else if (grade >= 1.6 && grade <= 2.5) {
      return "جيد جدًا";
    } else if (grade >= 2.6 && grade <= 3.5) {
      return "جيد";
    } else if (grade >= 3.6 && grade <= 4.0) {
      return "مقبول";
    } else if (grade >= 4.1 && grade <= 5.0) {
      return "راسب";
    } else {
      return "مدخلات غير صالحة";
    }
  };
  const handleCalculateClick = () => {
    const converted = calculateGrade(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue("");
    setConvertedValue("");
    setShowResult(false);
    setError(null);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  قم بتحويل معدلك الجامعي (مئوي أو تراكمي) إلى النظام الألماني
                  بسهولة ودقة. اعرف كيفية تحويل معدل البكالوريوس والماجستير إلى
                  النظام الألماني باستخدام هذه الأداة المفيدة.
                </p>
              </div>
              <br />
            </div>
            <hr />
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    تحويل المعدل الجامعي إلى النظام الألماني
                  </h2>
                </div>
                <hr />
                <div className="form-group">
                  <b>
                    <label>نوع المعدل:</label>
                  </b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === "grade"}
                      onChange={() => handleConversionTypeChange("grade")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label
                      htmlFor="gradeConversion"
                      className="form-check-label"
                    >
                      مئوي (100)
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === "gpa"}
                      onChange={() => handleConversionTypeChange("gpa")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label htmlFor="gpaConversion" className="form-check-label">
                      تراكمي (4.00)
                    </label>
                  </div>
                </div>
                <br />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="originalValue">
                        {conversionType === "grade"
                          ? "المعدل المئوي:"
                          : "المعدل التراكمي:"}
                      </label>
                    </b>
                    <input
                      type="text"
                      value={originalValue}
                      id="originalValue"
                      onChange={(e) => setOriginalValue(e.target.value)}
                      className="form-control"
                      style={{ width: "200px", marginRight: "4px" }}
                    />
                  </div>
                  <div>
                    <br />
                  </div>
                </div>
                <button
                  className="btn btn-success mt-3"
                  onClick={handleCalculateClick}
                >
                  احسب                </button>
                <br />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-12 col-md-7">
                {error && (
                  <div className="alert alert-warning">
                    <b>
                      <u>Error:</u>
                    </b>{" "}
                    {error}
                  </div>
                )}
                {showResult &&  (
                  <div
                    style={{ fontSize: "15px" }}
                    className="bg-light bg-gradient text-dark"
                  >
                    <div className="p-3 bg-success bg-gradient text-white">
                      <strong>النتيجة:</strong>
                    </div>
                    <b>
                      {conversionType === "grade"
                        ? `المعدل المئوي بالنسبة للنظام الألماني: ${convertedValue} (${getGradeTerm(
                            convertedValue
                          )})`
                        : `المعدل التراكمي بالنسبة للنظام الألماني: ${convertedValue} (${getGradeTerm(
                            convertedValue
                          )})`}
                    </b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      نظام تصنيف الدرجات الجامعية في ألمانيا
                    </h2>
                  </u>
                  <p>
                    في ألمانيا، يتم تصنيف الدرجات على مقياس من 1.0 إلى 5.0، حيث
                    1.0 هو الأفضل و5.0 هو الأسوأ. يمكن تقسيم الدرجات على النحو
                    التالي:
                  </p>
                  <table >
                    <thead>
                      <tr className="bmi-header">
                        <th>الدرجة الألمانية</th>
                        <th>المصطلحات الإنجليزية المكافئة</th>
                        <th>النسبة المئوية المكافئة</th>
                        <th>المعدل التراكمي (على مقياس 5 نقاط)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1.0 – 1.5</td>
                        <td>ممتاز</td>
                        <td>90-100%</td>
                        <td>5</td>
                      </tr>
                      <tr>
                        <td>1.6 – 2.5</td>
                        <td>جيد جدًا</td>
                        <td>80-89%</td>
                        <td>4</td>
                      </tr>
                      <tr>
                        <td>2.6 – 3.5</td>
                        <td>جيد</td>
                        <td>65-79%</td>
                        <td>3</td>
                      </tr>
                      <tr>
                        <td>3.6 – 4.0</td>
                        <td>مقبول</td>
                        <td>50-64%</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td>4.1 – 5.0</td>
                        <td>راسب</td>
                        <td>0-49%</td>
                        <td>1</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    هذه المعلومات تساعد في فهم كيفية تحويل المعدلات إلى النظام
                    الألماني ومعرفة ما يعادلها باللغة الإنجليزية والنسبة
                    المئوية.
                  </p>
                  <b className="text-primary">
                    <span>مثال: </span>
                    إذا كان لديك معدل تراكمي 3.0 على مقياس 4.0، يمكنك تحويله إلى
                    النظام الألماني باستخدام الأداة أعلاه وستحصل على النتيجة
                    المعادلة.
                  </b>
                  <p>
                    هذه الأداة مفيدة جدًا للطلاب الدوليين الذين يرغبون في متابعة
                    دراستهم في ألمانيا أو التقديم على وظائف تطلب معدل دراسي
                    معين.
                  </p>
                  <div>
                    <p>
                      تعد ألمانيا من أهم الدول المتطورة علميًا، وفيها أعرق
                      الجامعات التي يقصدها الطلاب من كل أنحاء العالم، ولا سيما
                      من البلاد العربية
                    </p>
                    <p className="alert alert-info">
                      أن في ألمانيا 15 جامعة من بين أفضل 200 جامعة في العالم،
                      فضلا عن أن نظام الدراسة في الجامعات الألمانية يتميز
                      بالرصانة العلمية والجدة في المنهج. وسبب اخر هو رخص
                      التكاليف الدراسية مقارنة ببقية الدول الأوروبية والمملكة
                      المتحدة والولايات المتحدة الأميركية.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GradeToGerman;
